import React, { useEffect, useState, useRef } from 'react';
import { SendIcon, PaperclipIcon, Mic, AudioLines, ChevronDown, Plus } from 'lucide-react';
import { copy } from '../../copy';
interface ComposerProps {
  onSend: (message: string) => void;
  disabled?: boolean;
}
export function Composer({
  onSend,
  disabled
}: ComposerProps) {
  const [value, setValue] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const handleInput = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${Math.min(textarea.scrollHeight, 200)}px`;
    }
  };
  const handleSubmit = (e?: React.FormEvent) => {
    e?.preventDefault();
    if (value.trim() && !disabled) {
      console.log('Composer submitting:', value);
      onSend(value.trim());
      setValue('');
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto';
      }
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };
  return <div className="sticky bottom-0 w-full bg-white dark:bg-[#1a1a1a] pb-8 pt-4" data-id="element-24">
      <div className="mx-auto max-w-3xl px-4" data-id="element-25">
        <form onSubmit={handleSubmit} className="relative flex flex-col rounded-2xl border border-slate-200 dark:border-[#333] bg-slate-50 dark:bg-[#222] p-4 shadow-sm dark:shadow-2xl focus-within:border-slate-300 dark:focus-within:border-[#444] transition-all" data-id="element-26">
          <textarea ref={textareaRef} rows={2} value={value} onChange={e => setValue(e.target.value)} onInput={handleInput} onKeyDown={handleKeyDown} placeholder={copy.composer.placeholder} className="w-full bg-transparent text-lg outline-none placeholder:text-slate-400 dark:placeholder:text-[#555] text-slate-900 dark:text-white resize-none min-h-[100px] pb-12" disabled={disabled} data-id="element-27" />

          <div className="absolute bottom-4 left-4 flex items-center gap-2" data-id="element-28">
            <button type="button" className="p-2 hover:bg-slate-200 dark:hover:bg-white/5 rounded-lg text-slate-500 dark:text-[#a3a3a3] transition-colors" data-id="element-29">
              <Plus size={20} data-id="element-30" />
            </button>
          </div>

          <div className="absolute bottom-4 right-4 flex items-center gap-4" data-id="element-31">
            <button type="button" className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg hover:bg-slate-200 dark:hover:bg-white/5 text-sm text-slate-500 dark:text-[#a3a3a3] transition-colors" data-id="element-32">
              <span data-id="element-33">{copy.composer.model}</span>
              <span className="text-slate-400 dark:text-[#555]" data-id="element-34">
                {copy.composer.mode}
              </span>
              <ChevronDown size={14} data-id="element-35" />
            </button>
            <button type="button" className="p-2 hover:bg-slate-200 dark:hover:bg-white/5 rounded-lg text-slate-500 dark:text-[#a3a3a3] transition-colors" data-id="element-36">
              <Mic size={20} data-id="element-37" />
            </button>
            <button type="button" className="p-2 hover:bg-slate-200 dark:hover:bg-white/5 rounded-lg text-slate-500 dark:text-[#a3a3a3] transition-colors" data-id="element-38">
              <AudioLines size={20} data-id="element-39" />
            </button>
            <button type="submit" disabled={!value.trim() || disabled} className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-900 dark:bg-white text-white dark:text-slate-900 shadow-sm transition-all hover:bg-slate-800 dark:hover:bg-slate-200 disabled:opacity-30" data-id="element-40">
              <SendIcon size={18} data-id="element-41" />
            </button>
          </div>
        </form>
        <p className="mt-2 text-center text-[10px] text-slate-400 dark:text-[#555]" data-id="element-42">
          {copy.composer.disclaimer}
        </p>
      </div>
    </div>;
}